<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->
<mat-form-field
	class="quick-search-form-field"
	[ngClass]="{ disabled: searchControl.disabled }"
	subscriptSizing="dynamic"
>
	<input automationId="quickSearch" matInput [formControl]="searchControl" placeholder="Quick Search..." />
	<mat-icon matPrefix>search</mat-icon>
	<mat-icon matSuffix [style.visibility]="searchControl.value ? 'visible' : 'hidden'" (click)="clearFilter()"
		>close
	</mat-icon>
</mat-form-field>
